export default __webpack_public_path__ + "static/media/frame-login-top.dc99509d.svg";